import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "container px-0" }
const _hoisted_4 = { class: "row fv-row mb-2 mt-2" }
const _hoisted_5 = { class: "col-sm-6 col-md-2 mb-1" }
const _hoisted_6 = { class: "d-flex align-items-center position-relative" }
const _hoisted_7 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_8 = { class: "col-sm-6 col-md-2 mb-1" }
const _hoisted_9 = { class: "d-flex align-items-center position-relative" }
const _hoisted_10 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_11 = { class: "col-sm-6 col-md-2 mb-1" }
const _hoisted_12 = { class: "d-flex align-items-center position-relative" }
const _hoisted_13 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_14 = { class: "col-sm-6 col-md-2 mb-1" }
const _hoisted_15 = { class: "d-flex align-items-center position-relative" }
const _hoisted_16 = { class: "col-sm-6 col-md-2 mb-1" }
const _hoisted_17 = { class: "d-flex align-items-center position-relative" }
const _hoisted_18 = { class: "card-body py-3" }
const _hoisted_19 = {
  key: 0,
  class: "row mb-5"
}
const _hoisted_20 = {
  class: "row mb-5",
  style: {"margin-right":"5px","padding-top":"10px","background-color":"aliceblue","border-radius":"15px 15px 15px 15px"}
}
const _hoisted_21 = {
  class: "col-lg-12 fv-row",
  style: {"text-align":"center"}
}
const _hoisted_22 = {
  class: "card-title align-items-center flex-column",
  style: {"font-weight":"700","font-size":"15px"}
}
const _hoisted_23 = { class: "col-lg-3 fv-row" }
const _hoisted_24 = { class: "row mb-3" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "col-lg-9 fv-row" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Nomor Identitas 1 ")
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_30 = { class: "col-7" }
const _hoisted_31 = { style: {"font-size":"12px"} }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Nomor Identitas 2 ")
], -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_35 = { class: "col-7" }
const _hoisted_36 = { style: {"font-size":"12px"} }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " TTL ")
], -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_40 = { class: "col-7" }
const _hoisted_41 = { style: {"font-size":"12px"} }
const _hoisted_42 = { class: "row" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Kelas ")
], -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_45 = { class: "col-7" }
const _hoisted_46 = { style: {"font-size":"12px"} }
const _hoisted_47 = { class: "row" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Detail Kelas ")
], -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_50 = { class: "col-7" }
const _hoisted_51 = { style: {"font-size":"12px"} }
const _hoisted_52 = { class: "row" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Jenis Kelamin ")
], -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_55 = { class: "col-7" }
const _hoisted_56 = { style: {"font-size":"12px"} }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { key: 1 }
const _hoisted_59 = { class: "row" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Alamat ")
], -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_62 = { class: "col-7" }
const _hoisted_63 = { style: {"font-size":"12px"} }
const _hoisted_64 = { class: "row" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Tags ")
], -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_67 = { class: "col-7" }
const _hoisted_68 = { style: {"font-size":"12px"} }
const _hoisted_69 = { class: "row" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Note ")
], -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_72 = { class: "col-7" }
const _hoisted_73 = { style: {"font-size":"12px"} }
const _hoisted_74 = { class: "row" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Status Kartu ")
], -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_77 = { class: "col-7" }
const _hoisted_78 = { style: {"font-size":"12px"} }
const _hoisted_79 = { class: "row" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Verifikasi Sekolah ")
], -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_82 = { class: "col-7" }
const _hoisted_83 = { style: {"font-size":"12px"} }
const _hoisted_84 = { class: "row mt-5 mb-5" }
const _hoisted_85 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_86 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_87 = ["label", "value"]
const _hoisted_88 = { class: "p-3" }
const _hoisted_89 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_90 = { class: "pagination" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_92 = { class: "card-body py-3" }
const _hoisted_93 = { class: "row mb-5" }
const _hoisted_94 = { class: "col-lg-6 fv-row" }
const _hoisted_95 = { class: "row px-3" }
const _hoisted_96 = { class: "col-lg-12 fv-row" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, "Preview Kartu Depan", -1)
const _hoisted_98 = ["src"]
const _hoisted_99 = { class: "col-lg-6 fv-row" }
const _hoisted_100 = { class: "row px-3" }
const _hoisted_101 = { class: "col-lg-12 fv-row" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, "Preview Kartu Belakang", -1)
const _hoisted_103 = ["src"]
const _hoisted_104 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_105 = { class: "row mt-5 mb-5" }
const _hoisted_106 = {
  class: "modal fade",
  tabindex: "-1",
  id: "modal-confirm-data"
}
const _hoisted_107 = { class: "modal-dialog" }
const _hoisted_108 = { class: "modal-content" }
const _hoisted_109 = {
  class: "modal-header",
  style: {"padding-top":"10px","padding-bottom":"5px"}
}
const _hoisted_110 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title justify-content-center" }, "Data Cetak", -1)
const _hoisted_111 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_112 = { class: "svg-icon svg-icon-2x" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("div", { class: "modal-body row pt-1" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "row",
    style: {"font-size":"16px","text-align":"center","margin-top":"15px"}
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-12 px-7" }, "Konfirmasi data yang akan dicetak?")
  ])
], -1)
const _hoisted_114 = {
  class: "modal-footer",
  style: {"padding-top":"5px","padding-bottom":"10px"}
}
const _hoisted_115 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-danger",
  "data-bs-dismiss": "modal"
}, " Batal ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.widgetClasses, "card"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control ps-15",
                  placeholder: "Cari Nama",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.nama) = $event)),
                  onKeyup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changePageSize(_ctx.e)))
                }, null, 544), [
                  [_vModelText, _ctx.nama]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control ps-15",
                  placeholder: "Cari NIS",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.nis) = $event)),
                  onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changePageSize(_ctx.e)))
                }, null, 544), [
                  [_vModelText, _ctx.nis]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control ps-15",
                  placeholder: "Cari Tag",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.tag) = $event)),
                  onKeyup: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changePageSize(_ctx.e)))
                }, null, 544), [
                  [_vModelText, _ctx.tag]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_Multiselect, {
                  class: "mx-1",
                  modelValue: _ctx.isPhoto,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isPhoto) = $event)),
                  placeholder: "Pilih Status Foto",
                  mode: "single",
                  "create-option": false,
                  options: _ctx.listDenganFoto,
                  searchable: true,
                  label: "name",
                  "track-by": "name",
                  "value-prop": "_id",
                  onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.pilihFilterFoto($event)))
                }, null, 8, ["modelValue", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_Multiselect, {
                  class: "mx-1",
                  modelValue: _ctx.isSchool,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isSchool) = $event)),
                  placeholder: "Pilih Status Verifikasi",
                  mode: "single",
                  "create-option": false,
                  options: _ctx.listValidasi,
                  searchable: true,
                  label: "name",
                  "track-by": "name",
                  "value-prop": "_id",
                  onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.pilihFilterValidasi($event)))
                }, null, 8, ["modelValue", "options"])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        (_ctx.listData.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listData, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "col-lg-6 fv-row pa-2 ma-2"
                }, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("h3", _hoisted_22, _toDisplayString(item.name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("img", {
                          src: item.photoUrl,
                          class: "img-fluid"
                        }, null, 8, _hoisted_25)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _hoisted_28,
                        _hoisted_29,
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("label", _hoisted_31, _toDisplayString(item.nis), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _hoisted_33,
                        _hoisted_34,
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("label", _hoisted_36, _toDisplayString(item.nisn), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _hoisted_38,
                        _hoisted_39,
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("label", _hoisted_41, _toDisplayString(item.placeOfBirth) + ", " + _toDisplayString(_ctx.dateOnly(item.dateOfBirth)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_42, [
                        _hoisted_43,
                        _hoisted_44,
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("label", _hoisted_46, _toDisplayString(item.grade), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _hoisted_48,
                        _hoisted_49,
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("label", _hoisted_51, _toDisplayString(item.gradeDetail), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_52, [
                        _hoisted_53,
                        _hoisted_54,
                        _createElementVNode("div", _hoisted_55, [
                          _createElementVNode("label", _hoisted_56, [
                            (item.gender == 'MALE')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_57, " Laki - Laki "))
                              : _createCommentVNode("", true),
                            (item.gender == 'FEMALE')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_58, " Perempuan "))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_59, [
                        _hoisted_60,
                        _hoisted_61,
                        _createElementVNode("div", _hoisted_62, [
                          _createElementVNode("label", _hoisted_63, _toDisplayString(item.address), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_64, [
                        _hoisted_65,
                        _hoisted_66,
                        _createElementVNode("div", _hoisted_67, [
                          _createElementVNode("label", _hoisted_68, _toDisplayString(_ctx.convertTags(item.tags)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_69, [
                        _hoisted_70,
                        _hoisted_71,
                        _createElementVNode("div", _hoisted_72, [
                          _createElementVNode("label", _hoisted_73, _toDisplayString(item.note), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_74, [
                        _hoisted_75,
                        _hoisted_76,
                        _createElementVNode("div", _hoisted_77, [
                          _createElementVNode("label", _hoisted_78, [
                            _createElementVNode("label", {
                              style: _normalizeStyle({
                        color: _ctx.colorStatus(item.isPrint),
                        fontSize: '12px',
                      })
                            }, _toDisplayString(_ctx.getStatusCetak(item.isPrint)), 5)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_79, [
                        _hoisted_80,
                        _hoisted_81,
                        _createElementVNode("div", _hoisted_82, [
                          _createElementVNode("label", _hoisted_83, [
                            _createElementVNode("label", {
                              style: _normalizeStyle({
                        color: _ctx.colorStatus(item.isSchoolValid),
                        fontSize: '12px',
                      })
                            }, _toDisplayString(_ctx.getStatusVerifikasiSekolah(item.isSchoolValid)), 5)
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_84, [
          _createElementVNode("div", _hoisted_85, [
            _createElementVNode("div", _hoisted_86, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("select", {
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.paging.size) = $event)),
                  placeholder: "Per page",
                  onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changePageSize()))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paging.perPageOptions, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item,
                      label: item,
                      value: item
                    }, null, 8, _hoisted_87))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.paging.size]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_88, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.paging.totalElements) + " entries ", 1)
          ]),
          _createElementVNode("div", _hoisted_89, [
            _createElementVNode("ul", _hoisted_90, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item previous", { disabled: _ctx.paging.page + 1 === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
                }, " Previous ")
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item next", { disabled: _ctx.paging.page + 1 === _ctx.paging.totalPages }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
                }, " Next ")
              ], 2)
            ])
          ])
        ]),
        _hoisted_91,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageData, (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("div", _hoisted_92, [
              _createElementVNode("div", _hoisted_93, [
                _createElementVNode("div", _hoisted_94, [
                  _createElementVNode("div", _hoisted_95, [
                    _createElementVNode("div", _hoisted_96, [
                      _hoisted_97,
                      _createElementVNode("img", {
                        alt: "image",
                        class: "pl-3",
                        style: {"max-width":"350px"},
                        src: _ctx.imageShow[index]?.image1
                      }, null, 8, _hoisted_98)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_99, [
                  _createElementVNode("div", _hoisted_100, [
                    _createElementVNode("div", _hoisted_101, [
                      _hoisted_102,
                      _createElementVNode("img", {
                        alt: "image2",
                        class: "pl-3",
                        style: {"max-width":"350px"},
                        src: _ctx.imageShow[index]?.image2
                      }, null, 8, _hoisted_103)
                    ])
                  ])
                ])
              ])
            ])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_104, [
          _createElementVNode("button", {
            class: "btn btn-primary me-3",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.verifyModal()))
          }, " Konfirmasi Data ")
        ])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_105, [
      _createElementVNode("div", _hoisted_106, [
        _createElementVNode("div", _hoisted_107, [
          _createElementVNode("div", _hoisted_108, [
            _createElementVNode("div", _hoisted_109, [
              _hoisted_110,
              _createElementVNode("div", _hoisted_111, [
                _createElementVNode("span", _hoisted_112, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                ])
              ])
            ]),
            _hoisted_113,
            _createElementVNode("div", _hoisted_114, [
              _hoisted_115,
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                "data-bs-dismiss": "modal",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.confirmStep()))
              }, " Ok ")
            ])
          ])
        ])
      ])
    ])
  ], 64))
}